<div class="checkout-shell" *ngIf="isCalculatorVisible">
    <div class="checkout-panel">
        <div class="loading-overlay" *ngIf="isPanelLoading || isLoading">
            <div class="loading-spinner"></div>
        </div>

        <header class="checkout-panel__header">
            <div class="checkout-panel__summary">
                <span class="checkout-panel__eyebrow">Caixa do posto</span>
                <div class="checkout-panel__totals">
                    <div class="checkout-panel__total-card">
                        <span>Total atual</span>
                        <strong>{{ price | currency: 'EUR' }}</strong>
                    </div>

                    <div class="checkout-panel__total-card checkout-panel__total-card--muted">
                        <span>Total registado</span>
                        <strong>{{ totalRegistered | currency: 'EUR' }}</strong>
                    </div>
                </div>

                <div class="checkout-panel__feedback">
                    <span class="checkout-panel__success" *ngIf="showSuccessMessage">Registado com sucesso</span>
                    <span class="checkout-panel__error" *ngIf="showErrorMessage">
                        <mat-icon>error_outline</mat-icon>
                        Erro ao registar
                    </span>
                </div>
            </div>

            <button class="checkout-panel__close" type="button" (click)="close()" aria-label="Fechar caixa">
                <mat-icon>close</mat-icon>
            </button>
        </header>

        <section class="checkout-panel__catalog">
            <div class="checkout-panel__catalog-header">
                <div>
                    <h3>Produtos disponíveis</h3>
                    <p>Seleciona toques para montar o registo atual. O estado de stock continua visível em cada produto.</p>
                </div>
            </div>

            <div class="product-list">
                <button
                    *ngFor="let product of products"
                    type="button"
                    class="product"
                    [ngStyle]="{'background-color': product.backgroundColor || '#13b2c3', 'color': product.color || '#fff'}"
                    [ngClass]="{
                        'selected': product.touchedTimes > 0,
                        'product--low-stock': isLowStock(product),
                        'product--negative-stock': isNegativeStock(product)
                    }"
                    (click)="priceClicked(product.id)">
                    <span class="product-name">{{ getProductDisplayName(product) }}</span>
                    <span class="product-price">{{ product.price | currency:'EUR' }}</span>
                    <span
                        *ngIf="showStockBadge(product)"
                        class="product-stock"
                        [ngClass]="{
                            'product-stock--low': isLowStock(product),
                            'product-stock--negative': isNegativeStock(product)
                        }">
                        {{ getStockBadgeText(product) }}
                    </span>
                    <span *ngIf="product.touchedTimes" class="counter">{{ product.touchedTimes }}</span>
                </button>
            </div>
        </section>

        <footer class="checkout-panel__footer">
            <div class="checkout-panel__footer-summary">
                <div class="checkout-panel__footer-total">
                    <span>Total atual</span>
                    <strong>{{ price | currency: 'EUR' }}</strong>
                </div>
                <div class="checkout-panel__footer-registered">
                    Registado: {{ totalRegistered | currency: 'EUR' }}
                </div>
            </div>

            <div class="checkout-panel__footer-meta">
                <span *ngIf="isPartialDeletingCalculator" class="checkout-panel__mode-pill">Modo remover ativo</span>
            </div>

            <div class="action-buttons">
                <button type="button" (click)="resetCalculatingScore()" class="action-btn clear-btn">Limpar</button>
                <button
                    type="button"
                    (click)="partialDeleteCalculator()"
                    class="action-btn partial-delete"
                    [ngClass]="{'focus': isPartialDeletingCalculator}">
                    Remover
                </button>
                <button
                    type="button"
                    (click)="showChangePanel()"
                    class="action-btn troco-btn"
                    [disabled]="price <= 0 || isLoading">
                    Troco
                </button>
                <button
                    type="button"
                    (click)="registerTransaction()"
                    class="action-btn register-btn"
                    [disabled]="price <= 0 || isLoading">
                    <ng-container *ngIf="!isLoading">Registar</ng-container>
                    <ng-container *ngIf="isLoading">
                        <mat-icon class="loading-icon">refresh</mat-icon>
                    </ng-container>
                </button>
            </div>
        </footer>
    </div>
</div>

<div class="checkout-shell checkout-shell--dialog" *ngIf="isChangePanelVisible">
    <div class="change-panel">
        <div class="loading-overlay" *ngIf="isLoading">
            <div class="loading-spinner"></div>
        </div>

        <header class="change-panel__header">
            <button class="change-panel__back" type="button" (click)="goBack()" aria-label="Voltar">
                <mat-icon>arrow_back</mat-icon>
            </button>

            <div class="change-panel__title">
                <span>Troco</span>
                <strong>{{ price | currency:'EUR' }}</strong>
            </div>
        </header>

        <div class="checkout-panel__error checkout-panel__error--block" *ngIf="showErrorMessage">
            <mat-icon>error_outline</mat-icon>
            {{ errorMessage }}
        </div>

        <section class="change-section">
            <div class="field">
                <label>Valor recebido</label>
                <input
                    type="number"
                    [(ngModel)]="amountReceived"
                    (input)="onAmountReceivedChanged(amountReceived)"
                    placeholder="Insira o valor recebido"
                    [value]="amountReceived == null ? '' : amountReceived"/>
            </div>

            <div class="field field--summary">
                <label>Troco</label>
                <div class="troco">
                    {{
                        (amountReceived == null || amountReceived === 0)
                            ? (0 | currency:'EUR')
                            : ((amountReceived - price) | currency:'EUR')
                    }}
                </div>
            </div>
        </section>

        <footer class="action-buttons action-buttons--dialog">
            <button type="button" class="action-btn clear-btn" (click)="goBack()">Voltar</button>
            <button
                type="button"
                (click)="registerTransactionByChange()"
                class="action-btn register-btn"
                [disabled]="price <= 0 || isLoading">
                <ng-container *ngIf="!isLoading">Registar</ng-container>
                <ng-container *ngIf="isLoading">
                    <mat-icon class="loading-icon">refresh</mat-icon>
                </ng-container>
            </button>
        </footer>
    </div>
</div>
